module.exports = __webpack_public_path__ + "static/media/logo.a09efc61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 1504
// module chunks = 0